import React, { useContext } from "react";
import { Icon, Stack, Text, Theme } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { getStatusName } from "../../common/utils/getStatusName";
import { OrderDashboardContext } from "../provider/OrderDashboardContext";

export const OrderDetailsStatus: React.FunctionComponent = () => {
    const { orderDashboardItem } = useContext(OrderDashboardContext);

    const status = orderDashboardItem.status;

    return (
        <Stack verticalAlign="center" horizontal={true} tokens={{ childrenGap: 8 }}>
            <Icon size={16} color={Theme.palette.themePrimary} iconName={statusIcons[status]} />
            <Text>Status: </Text>
            <Text testId="order-status">{getStatusName(status)}</Text>
        </Stack>
    );
};

const statusIcons: Record<OrderStatus, string> = {
    [OrderStatus.Pending]: "Questionnaire",
    [OrderStatus.Approved]: "Approved",
    [OrderStatus.EncodingFailed]: "ErrorBadge",
    [OrderStatus.Encoded]: "Completed",
    [OrderStatus.DeliveryApproved]: "Mail",
    [OrderStatus.DeliveryCompleted]: "MailCheck",
    [OrderStatus.DeliveryFailed]: "MailUndelivered",
    [OrderStatus.Rejected]: "PageRemove",
    [OrderStatus.DeliveryError]: "Error",
    [OrderStatus.Cancelled]: "Error",
    [OrderStatus.Overridden]: "ViewOriginal"
};
